import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useUserContext } from "../../../providers/userProvider";
import { sendEmailVerification } from "firebase/auth";

// Define the ReminderBanner functional component
const VerificationBanner: React.FC = () => {
  // Get the user context values
  const { isVerified, user } = useUserContext();
  // State to manage the message to be displayed in the banner
  const [message, setMessage] = useState<string | null>(null);

  // Function to handle sending the verification email
  const handleResendVerificationEmail = async () => {
    if (user) {
      try {
        await sendEmailVerification(user);
        setMessage("Verification email sent. Please check your inbox.");
      } catch (error) {
        setMessage("Failed to send verification email. Please try again.");
      }
    }
  };

  if (isVerified || !user) {
    return <></>;
  }

  return (
    <Box data-testid="banner-text"
      sx={{
        position: "sticky",
        top: 0,
        width: "100%",
        backgroundColor: "red",
        color: "white",
        textAlign: "center",
        padding: 1,
        zIndex: 1000,
      }}
    >
      <Typography variant="body1">
        Your email is not verified. Please check your inbox to verify your
        email. Don't forget to check your spam folder.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleResendVerificationEmail}
        sx={{ marginTop: 1 }}
      >
        Resend Verification Email
      </Button>
      {message && (
        <Typography variant="body2" sx={{ marginTop: 1 }}>
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default VerificationBanner;
